export default __webpack_public_path__ + "static/media/gluten-free-000000.1fe17bb8.png";